import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    integrations: [],
    loading: false,
  }),
  mutations: {
    setIntegrations(state, payload) {
      state.integrations = payload
    },
    setLoading(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchIntegrations(context) {
      return withLoading(async () => {
        const response = await api.get("/manage/integrations")
        context.commit("setIntegrations", response.data)
        return response.data
      }, context)
    },

    async createIntegration(context, params) {
      return withLoading(async () => {
        const response = await api.post("/manage/integrations", params)
        context.commit("setIntegrations", response.data)
        return response.data
      }, context)
    },

    async updateIntegration(context, { id, params }) {
      return withLoading(async () => {
        const response = await api.put(`/manage/integrations/${id}`, params)
        context.commit("setIntegrations", response.data)
        return response.data
      }, context)
    },

    async deleteIntegration(context, id) {
      return withLoading(async () => {
        const response = await api.delete(`/manage/integrations/${id}`)
        context.commit("setIntegrations", response.data)
        return response.data
      }, context)
    },
  }
 
}